import {
  HttpEvent,
  HttpInterceptorFn,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap } from 'rxjs/operators';
import { throwError, from, Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { AlertService } from '@rslweb/shared';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: (req: HttpRequest<unknown>) => Observable<HttpEvent<unknown>>
): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);
  const alertService = inject(AlertService);  
  const authService = inject(AuthService);
  const token = sessionStorage.getItem('token');

  if (req.url.includes('/auth/')) {
    return next(req);
  }

  if (token) {
    const clonedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });

    return next(clonedReq).pipe(
      catchError((error) => {
        if (error.status === HttpStatusCode.Unauthorized) {
          return from(authService.refreshSession()).pipe(
            switchMap((refreshed) => {
              if (refreshed) {
                const newToken = sessionStorage.getItem('token');
                const retryReq = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${newToken}`,
                  },
                });
                return next(retryReq);
              } else {
                authService.Logout();
                return throwError(
                  () => new Error('Session expired. Please login again.')
                );
              }
            }),
            catchError((refreshError) => {
              alertService.error(
                refreshError?.error?.message ||
                  'Session expired. Please login again.'
              );
              authService.Logout();
              return throwError(
                () =>
                  refreshError?.error?.message ||
                  'Session expired. Please login again.'
              );
            })
          );
        }
        return throwError(() => error?.error?.message || 'An error occurred');
      })
    );
  }

  return next(req);
};
